import {
  CcfBox,
  CcfCalendarIcon,
  CcfHeader,
  CcfTabs,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getApplicationDirection } from '../../global.app.slice';
import styles from './ccf-app-wem.module.scss';
import { CcfAppSchedule, CcfWemLeftNav } from '@nice-ccf/ui-components';
import { makeStyles } from '@mui/styles';
import { Theme, useTheme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';

/* eslint-disable-next-line */
export interface CcfAppWemProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appSpaceHeader: {
      background: `${theme.palette.background.level1} 0% 0% no-repeat padding-box`,
      borderRadius: '5px 5px 0px 0px',
      opacity: 1,
      display: 'flex',
      alignItems: 'center',
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingLeft: '5px',
      justifyContent: 'space-between',
      marginTop: '0px !important',
      '& section': {
        marginBottom: '0px !important',
        alignItems: 'center',
      },
      '& > div': {
        marginTop: '0px !important',
      },
      '& label': {
        color: theme.palette.text.secondary,
        marginLeft: '4px !important',
        marginTop: '0px !important',
        fontWeight: 'bold',
        lineHeight: '1',
      },
      '& svg': {
        verticalAlign: 'middle',
      },
    },
  })
);
/**
 * CcfAppWem - used to display static image in wem landing page
 * @param props - CcfAppWemProps
 * @example `<CcfAppWem inboxCardState={inboxCardStateVal} `/`>`
 */
export function CcfAppWem(props: CcfAppWemProps) {
  const classes = useStyles();
  const appDirection: any = useSelector(getApplicationDirection);
  const [tab, setTab] = useState(0);

  /**
   * Updating Tab index while Switching Tabs in home Panel to show tabs data
   * @param newTabIndex -number
   * @example - handleChange(1)
   */
  const handleChange = (newValue: number) => {
    setTab(newValue);
  };

  return (
    <CcfBox className={styles.ccfHomeContainer} style={{ width: '100%' }}>
      <CcfBox className={styles.wemContainer}>
        <CcfBox style={{ background: 'white', height: '100%' }}>
          <CcfBox className={classes.appSpaceHeader}>
            <CcfHeader
              headerText={'WEM'}
              headerTextClassess={styles.headerText}
              RightIcon={false}
              isNewWindowIcon
              direction={appDirection}
            ></CcfHeader>
          </CcfBox>
          <CcfWemLeftNav />
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}
